import React from "react";
import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { useFileCellAffordances } from "../../../common/controls";
import {
  useSnapshotExtension,
  useSnapshotExtensionTop,
} from "../../../common/controls";
import { Box, FormControl, Typography } from "@mui/material";

type UserAttachmentEditionViewProps = {
  snapshotData: any;
  // Propagated from the top-level snapshot view so nested tables can resolve
  // the snapshot-scoped file-download endpoint (/<snapshotEntityName>.data/
  // <snapshotRecordId>/<fileUuid>). Both are optional at the type level but
  // required at runtime for the download / view affordances to work.
  snapshotEntityName?: string;
  snapshotRecordId?: string;
};

export const UserAttachmentEditionView: React.FC<
  UserAttachmentEditionViewProps
> = ({ snapshotData, snapshotEntityName, snapshotRecordId }) => {
  const { langStore } = useRootStore();
  const renderExtensionTop = useSnapshotExtensionTop("UserAttachmentEdition");
  const renderExtension = useSnapshotExtension("UserAttachmentEdition");

  const { renderFileCell, excelViewerElement } = useFileCellAffordances({
    snapshotEntityName,
    snapshotRecordId,
    enableDownload: true,
  });
  return (
    <>
      {renderExtensionTop ? renderExtensionTop(snapshotData) : null}
      <FormControl fullWidth>
        <ShowMultiLine
          label={langStore.UserAttachmentEditionNameLabel}
          value={String(snapshotData?.name ?? "")}
        />
        <Box sx={{ my: 1 }}>
          <Typography variant="caption" color="text.secondary" display="block">
            {langStore.UserAttachmentEditionFileLabel}
          </Typography>
          {snapshotData?.file?.filename ? (
            <Box sx={{ display: "flex" }}>
              {renderFileCell(
                {
                  file: snapshotData?.file.filename,
                  file_data: snapshotData?.file,
                },
                "file",
                snapshotData?.file?.mimetype ?? "",
                snapshotData?.file.filename
              )}
            </Box>
          ) : null}
        </Box>
        <ShowMultiLine
          label={langStore.UserAttachmentEditionNotesLabel}
          value={String(snapshotData?.notes ?? "")}
        />
      </FormControl>
      {renderExtension ? renderExtension(snapshotData) : null}

      {excelViewerElement}
    </>
  );
};
